export default "__VITE_ASSET__Cm23F2d1__"